const generalMixin = {
  data() {
    return {
      isBusy: false,
    };
  },
  computed: {
    loginData() {
      return this.$store.state.auth.loginStore.profile.data;
    },
    user() {
      return this.loginData ? this.loginData.user : null;
    },
    userIsSuperAdmin() {
      return this.checkUserRole("ROLE_SUPER_ADMIN");
    },
    userIsAdmin() {
      return this.checkUserRole("ROLE_ADMIN");
    },
    userIsAgent() {
      return this.checkUserRole("ROLE_AGENT");
    },
    userIsClient() {
      return this.checkUserRole("ROLE_CLIENT");
    },
    userIsBuyer() {
      return this.checkUserRole("ROLE_BUYER");
    },
    userIsExternalAgent() {
      return this.checkUserRole("ROLE_EXTERNAL_AGENT");
    },
    userIsRI() {
      return this.checkUserRole("ROLE_RI");
    },
    companyIsPending() {
      if (!this.user) {
        return false;
      } else {
        let isPending = false;
        if (
          this.user.userDetails.company &&
          this.user.userDetails.company.status === 2
        ) {
          isPending = true;
        }

        return isPending;
      }
    },
  },
  methods: {
    checkUserRole(userRole) {
      if (!this.user) {
        return false;
      } else {
        const { roles } = this.user;
        return roles.find((role) => role.name === userRole);
      }
    },
    apiErrorMessage(error, fallback = "An error occurred") {
      return (
        error?.response?.data?.messages?.[0]?.info ||
        error?.response?.data?.message ||
        fallback
      );
    },
    makeToast(title, text, type) {
      this.$root.$bvToast.toast(text, {
        title: title,
        autoHideDelay: 5000,
        variant: type,
        solid: true,
      });
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    closeModal(modalId, callback = null) {
      this.$bvModal.hide(modalId);
      if (callback) callback();
    },
    showConfirmDeleteBox() {
      return this.$bvModal.msgBoxConfirm(
        "Please confirm that you want to delete the item.",
        {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okTitle: "YES",
          okVariant: "success",
          cancelTitle: "NO",
          cancelVariant: "danger",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        }
      );
    },

    showConfirmBuyCar() {
      return this.$bvModal.msgBoxConfirm("Are you sure to buy this car?", {
        title: "Please Confirm",
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        okTitle: "YES",
        cancelTitle: "NO",
        cancelVariant: "danger",
        footerClass: "p-2",
        hideHeaderClose: false,
        centered: true,
      });
    },
    showAcceptOfferConfirmation() {
      return this.$bvModal.msgBoxConfirm("Are you sure to accept this offer?", {
        title: "Please Confirm",
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        okTitle: "YES",
        cancelTitle: "NO",
        cancelVariant: "danger",
        footerClass: "p-2",
        hideHeaderClose: false,
        centered: true,
      });
    },
    formatFileName(module, vehicle = null, providerName = null) {
      let fileName = "";
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, '0');
      const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0
      const yy = String(today.getFullYear()).slice(-2);
      const dateStr = `${dd}-${mm}-${yy}`;

      if (!vehicle) {
        fileName = `${module}_${dateStr}`;
        return fileName;
      }

      const vinLast6 = vehicle?.vinNumber?.vinNumber ? vehicle.vinNumber.vinNumber.slice(-6) : 'NOVIN';
      const stock = vehicle?.stockNumber || 'NOSTOCK';

      if (providerName) {
        // For transfer and sold: Transport_(Provider Name)_(VIN)_(STOCK)_(DATE)
        fileName = `Transport_${providerName}_${vinLast6}_${stock}_${dateStr}`;
      } else {
        // For other modules: (module)_(VIN last 6)_(STOCK)_(DATE)
        fileName = `${module}_${vinLast6}_${stock}_${dateStr}`;
      }

      return fileName;
    },
  },
};

export { generalMixin };
